import React from 'react';
import { Button } from '@/components/ui/Button';
import { X, Linkedin, Star } from 'lucide-react';

interface Creator {
    name: string;
    role: string;
    image: string;
    description: string;
    linkedin?: string;
}

const creators: Creator[] = [
    {
        name: "Gustavo Lopes",
        role: "Marketing & Tecnologia",
        image: "/images/criadores/gstv.jpeg",
        description: "Com mais de 9 anos de estrada em Marketing, sou um profissional que une estratégia e 'mão na massa'. Aplico minha visão 360° (B2B/B2C) e minha paixão por IA e automação para resolver dores reais do mercado, em clientes de vários nichos. Acredito que a inovação nasce da mistura entre criatividade, estratégia e tecnologia.",
        linkedin: "https://www.linkedin.com/in/gstvlopes"
    },
    {
        name: "Marília Medrado",
        role: "Marketing & IA",
        image: "/images/criadores/mari.jpeg",
        description: "Com cerca de 15 anos de carreira, com passagens em empresas nacionais e multinacionais, atuo na intersecção entre marketing, branding, estratégia e performance. Entusiasta de IA, uso a tecnologia como meio para aumentar ainda mais a eficiência, a criatividade e os resultados nos times e nos negócios.",
        linkedin: "https://www.linkedin.com/in/marilia-medrado/"
    }
];

interface CreatorsModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const CreatorsModal: React.FC<CreatorsModalProps> = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div 
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200"
            onClick={onClose}
        >
            <div 
                className="bg-white rounded-2xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden animate-in zoom-in-95 duration-200"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="p-6 border-b border-slate-100 flex items-center justify-between shrink-0">
                    <div className="flex items-center gap-2">
                        <Star className="text-amber-500 fill-amber-500" size={24} />
                        <h2 className="text-xl font-bold text-slate-900">Conheça os Criadores</h2>
                    </div>
                    <Button variant="ghost" onClick={onClose} icon={X} className="h-8 w-8 p-0 rounded-full" />
                </div>

                <div className="p-6 md:p-10 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 overflow-y-auto">
                    {creators.map((creator, idx) => (
                        <div key={idx} className="flex flex-col items-center text-center space-y-5 h-full">
                            <div className="relative group">
                                <div className="absolute inset-0 bg-indigo-500 rounded-full blur opacity-20 group-hover:opacity-40 transition-opacity duration-500"></div>
                                <img
                                    src={creator.image}
                                    alt={creator.name}
                                    className="relative w-32 h-32 rounded-full object-cover border-4 border-white shadow-lg transition-transform duration-300 group-hover:scale-105"
                                />
                            </div>

                            <div>
                                <h3 className="text-xl font-bold text-slate-900">{creator.name}</h3>
                                <p className="text-sm text-indigo-600 font-semibold">{creator.role}</p>
                            </div>

                            <div className="flex-grow flex items-center px-4">
                                <p className="text-sm text-slate-600 leading-relaxed text-justify">
                                    {creator.description}
                                </p>
                            </div>

                            {creator.linkedin && (
                                <a
                                    href={creator.linkedin}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="mt-4 inline-flex items-center gap-2 px-6 py-2.5 bg-[#0077b5] hover:bg-[#006396] text-white text-sm font-bold rounded-full transition-all hover:shadow-md transform hover:-translate-y-0.5"
                                >
                                    <Linkedin size={16} />
                                    Conectar no LinkedIn
                                </a>
                            )}
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};
